<template>
	<li class="app-sidebar-item" :key="$route.path">
		<router-link :to="to" v-if="to !== null" :id="elementId" :exact="exact">
			<span class="app-sidebar-item-icon">
				<font-awesome-icon :icon="icon" fixed-width />
			</span>
			<span class="app-sidebar-item-label" v-show="!appBarCollapsed">
				<slot>Sidebar Item</slot>
			</span>
		</router-link>

		<a :href="href" @click="$emit('click')" v-else :id="elementId">
			<span class="app-sidebar-item-icon">
				<font-awesome-icon :icon="icon" fixed-width />
			</span>
			<span class="app-sidebar-item-label" v-show="!appBarCollapsed">
				<slot>Sidebar Item</slot>
			</span>
		</a>

		<b-tooltip :target="elementId" placement="right" v-if="appBarCollapsed">
			<slot>Sidebar Item</slot>
		</b-tooltip>
	</li>
</template>

<script>
export default {
	props: {
		to: { default: null },
		exact: { type: Boolean, default: false },
		href: { default: '#' },
		icon: { default: 'cube' }
	},

	computed: {
		/**
		 * Returns the `appBarCollapsed` property from the store.
		 *
		 * @returns {boolean}
		 */
		appBarCollapsed () {
			return this.$store.getters['ui/appBarCollapsed'];
		},

		/**
		 * Returns a unique ID to be used by the Bootstrap tooltip feature
		 *
		 * @returns {string}
		 */
		elementId () {
			return '_' + Math.random().toString(36).substr(2, 9);
		}
	}
};
</script>

<style lang="scss">
@import '../../_variables.scss';

.app-sidebar-item {
	> a {
		display: block;
		padding: 15px;
		color: $app-sidebar-color;
		line-height: 20px;
		cursor: pointer;

		.app-sidebar-item-icon {
			vertical-align: middle;
		}

		.app-sidebar-item-label {
			display: inline-block;
			margin-left: 15px;
			font-size: 13px;
		}

		&:hover {
			text-decoration: none;
			background-color: rgba(white, 0.1);
			color: white;
		}

		&.router-link-active {
			background-color: rgba(white, 0.25);
		}
	}
}
</style>
